import { findDistrict, findProvince, TR_PROVINCES } from '@zt/content/tr-address';
import { Field, Select } from '@zt/ui';
import { HelpTip } from './help';
import { useT } from './i18n';

/**
 * Panel adres formlarında il ve ilçe seçimi (F5B-17). Kayıtlı değer listede eşleşirse resmî yazımla seçili gelir;
 * eşleşmezse (eski adres) "… (listede yok)" seçeneği olarak korunur, kaydetmek için listeden seçilmesi gerekir.
 */
export function TrPlaceFields({
  city,
  district,
  onChange,
  cityLabel,
  districtLabel,
  required,
  districtRequired,
  cityError,
  districtError,
}: {
  city: string;
  district: string;
  onChange: (v: { city: string; district: string }) => void;
  cityLabel: string;
  districtLabel: string;
  required: boolean;
  /** İlçe de zorunlu mu (ör. satış noktası); varsayılan isteğe bağlı. */
  districtRequired?: boolean;
  cityError?: string;
  districtError?: string;
}) {
  const t = useT();
  const province = findProvince(city);
  const legacyCity = !province && city.trim() ? city : null;
  const districtValue = province ? (findDistrict(province, district) ?? district) : district;
  const legacyDistrict =
    district.trim() && (!province || !findDistrict(province, district)) ? district : null;
  return (
    <>
      <Field
        label={cityLabel}
        required={required}
        error={cityError}
        help={<HelpTip k="orders.address_place" />}
      >
        {(p) => (
          <Select
            {...p}
            value={province?.name ?? city}
            onChange={(e) => onChange({ city: e.target.value, district: '' })}
          >
            <option value="">{t('admin.orders.chooseProvince')}</option>
            {legacyCity && (
              <option value={legacyCity}>{t('admin.orders.legacyPlace', { value: legacyCity })}</option>
            )}
            {TR_PROVINCES.map((x) => (
              <option key={x.code} value={x.name}>
                {x.name}
              </option>
            ))}
          </Select>
        )}
      </Field>
      <Field
        label={districtLabel}
        required={districtRequired}
        optionalLabel={t('common.optional')}
        error={districtError}
      >
        {(p) => (
          <Select
            {...p}
            value={districtValue}
            disabled={!province && !legacyDistrict}
            onChange={(e) => onChange({ city: province?.name ?? city, district: e.target.value })}
          >
            <option value="">
              {province ? t('admin.orders.chooseDistrict') : t('admin.orders.chooseProvinceFirst')}
            </option>
            {legacyDistrict && (
              <option value={legacyDistrict}>
                {t('admin.orders.legacyPlace', { value: legacyDistrict })}
              </option>
            )}
            {province?.districts.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </Select>
        )}
      </Field>
    </>
  );
}
